import { render, staticRenderFns } from "./PermissoesCadastro.vue?vue&type=template&id=88b9f750"
import script from "./PermissoesCadastro.vue?vue&type=script&lang=js"
export * from "./PermissoesCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports